import React, { createContext, useContext, useEffect, useState } from "react";
import useAxiosPrivate, { axiosHrPrivate } from "../api/useAxios";
import { useAuth } from "./auth";

export const definitions = {
    certificateCategoryInfo: { name: "certificateCategoryInfo", url: "/api/CertificateCategoryInfo" },
    //{name:"", id:""},
    //{name:"", id:""},
}

function DefinitionListProvider(props) {
    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)
    const { activeLanguage } = useAuth()
    const [definitionList, setDefinitionList] = useState([])

    const getDefinitonListFromApi = async (definition) => {
        try {
            var response = await axiosPrivate.get(definition.url)
            if (response) {
                if (response.data?.data) {
                    return response?.data?.data.map(item => ({ id: item.id, text: item.name }))
                }
            }
            return null
        } catch (error) {
            console.log("getDefinitonListFromApi error : ", error)
        }
    }

    const checkValue = (definition) => {

        if (!definition?.expireDate)
            return false
        // if (definition.language != activeLanguage)
        //     return false

        var now = new Date(Date.now())
        var expireDate = new Date(definition.expireDate)
        return expireDate > now

    }

    const getDefinitionList = async (definition, refresh) => {

        var result = ""

        if (!refresh) {
            result = definitionList.find((item) => item.name === definition.name)

            if (result && checkValue(result))
                return result.data

            result = JSON.parse(localStorage.getItem("Definition-" + definition.name))

            if (result && checkValue(result)) {
                setDefinitionList(prevState => [...prevState, result]);
                return result.data
            }
        }

        var data = await getDefinitonListFromApi(definition)

        if (data) {
            var expireDate = new Date(Date.now() + (1000 * 60 * 60 * 24));//1 günlük
            //Datata bir yerde versiyon tutup bu versiyona göre de güncelletebiliriz. Kayıt eklendiğinde versiyon yükselir
            result = {
                name: definition.name,
                expireDate: expireDate,
                //language: activeLanguage,
                data: data,
            }
            localStorage.setItem("Definition-" + definition.name, JSON.stringify(result))
            setDefinitionList(prevState => [...prevState, result]);
            return result.data
        }
    }

    return (
        <DefinitionListContext.Provider value={{
            getDefinitionList
        }} {...props} />
    );

}

const DefinitionListContext = createContext({})
const useDefinitionList = () => useContext(DefinitionListContext)

export { DefinitionListProvider, useDefinitionList }